module.exports = __webpack_public_path__ + "img/document-verified-disabled.eabf7b18.svg";